<template>
  <select :value="value" @change="input" v-on="listeners">
    <option value="down right">Notify in the top left corner</option>
    <option value="down center">Notify in the top center</option>
    <option value="down left" selected>Notify in the top right corner</option>
    <option value="up right">Notify in the bottom left corner</option>
    <option value="up center">Notify in the bottom center</option>
    <option value="up left">Notify in the bottom right corner</option>
  </select>
</template>

<script>
import BaseSelect from "./BaseSelect";

export default {
  name: "PositionSelect",
  extends: BaseSelect
};
</script>

<style lang="css"></style>
